import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IAnnouncementResource } from "../types";

export type IAnnouncementDeleteMutationParameters = {
    announcement: RelationalValue<IAnnouncementResource>;
};

export type IAnnouncementDeleteMutationResult = void;

export const announcementDeleteMutation: IApiMutationFunction<IAnnouncementDeleteMutationParameters> = ({
    announcement,
}) => ({
    method: "DELETE",
    url: `/announcements/${mapRelationalValue(announcement)}`,
});

export const useAnnouncementDeleteMutation = createApiMutationHook<
    IAnnouncementDeleteMutationParameters,
    IAnnouncementDeleteMutationResult
>(announcementDeleteMutation);
